'use client'

import { ScenarioNodeWithVideoUrl } from '@/orval/generated/public/model'
import { FC, useEffect, useState } from 'react'
import SPCTASection from './SPCTASection'
import SPDetailPanelStyles from './SPDetailPanelStyles'
import SPPerformerSection from './SPPerformerSection'
import SPVideoTextSection from './SPVideoTextSection'

export interface SPDetailPanelProps {
  currentNode: ScenarioNodeWithVideoUrl
  onClose: () => void
  onCTAClick: () => void
  ctaUrl?: string | null
  ctaLabel?: string | null
}

const SPDetailPanel: FC<SPDetailPanelProps> = ({ currentNode, onClose, onCTAClick, ctaUrl, ctaLabel }) => {
  const [isClosing, setIsClosing] = useState(false)

  // Get video info from API data (template takes priority, show each performer separately)
  const title = currentNode.video?.title || currentNode.title || '動画タイトル'
  const performer1Name = currentNode.video?.performerTemplate?.name || currentNode.video?.performer || null
  const performer1Profile = currentNode.video?.performerTemplate?.profile || null
  const performer2Name = currentNode.video?.performerTemplate2?.name || null
  const performer2Profile = currentNode.video?.performerTemplate2?.profile || null
  const videoText1 = currentNode.video?.videoTextTemplate?.videoText || currentNode.video?.videoText || ''
  const videoText2 = currentNode.video?.videoTextTemplate2?.videoText || ''

  // Handle close with animation
  const handleClose = () => {
    setIsClosing(true)
  }

  // Handle animation end
  useEffect(() => {
    if (isClosing) {
      const timer = setTimeout(() => {
        onClose()
      }, 300)
      return () => clearTimeout(timer)
    }
  }, [isClosing, onClose])

  return (
    <>
      <SPDetailPanelStyles />

      <div className="sp-detail-overlay">
        <div className="sp-detail-backdrop" onClick={handleClose} />

        <div className={`sp-detail-panel ${isClosing ? 'closing' : ''}`}>
          <div className="sp-detail-header">
            <button type="button" className="sp-detail-close" onClick={handleClose}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </div>

          <div className="sp-detail-content">
            <h2 className="sp-detail-title">{title}</h2>

            {performer1Name && <SPPerformerSection name={performer1Name} profile={performer1Profile} />}
            {performer2Name && <SPPerformerSection name={performer2Name} profile={performer2Profile} />}
            {videoText1 && <SPVideoTextSection content={videoText1} />}
            {videoText2 && <SPVideoTextSection content={videoText2} />}
          </div>

          {ctaUrl && <SPCTASection onCTAClick={onCTAClick} ctaLabel={ctaLabel} />}
        </div>
      </div>
    </>
  )
}

export default SPDetailPanel
